module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notice delTeam",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.ensure($event)
      }
    }
  }, [_c('div', {
    staticClass: "noticeHead"
  }, [_vm._v("\n    " + _vm._s(_vm.params.noticeTitle) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "deleteNotice"
  }, [_c('div', {
    staticClass: "deleteText"
  }, [_c('p', [_vm._v("确定删除“ "), _c('span', [_vm._v(_vm._s(_vm.title))]), _vm._v(" ”吗？")]), _vm._v(" "), _c('p', [_vm._v("删除小组后，该小组下的学生会回归到未分组")])])]), _vm._v(" "), _c('div', {
    staticClass: "noticeClose",
    on: {
      "click": _vm.closeNotice
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "noticeBottom"
  }, [_c('button', {
    staticClass: "sure",
    on: {
      "click": _vm.ensure
    }
  }, [_vm._v("确定")]), _vm._v(" "), _c('button', {
    staticClass: "cancel",
    on: {
      "click": _vm.abolish
    }
  }, [_vm._v("取消")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d92a574","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notice/delTeam.vue
// module id = 1173
// module chunks = 1